import React, { useState, useContext } from 'react';
import { FiCheck } from 'react-icons/fi';
import { useIntl } from 'react-intl';

import { useStateFromProp } from '~hooks/common';

import { PusherContext } from '~contexts/pusher';

import Button from '~components/button';
import Modal from '~components/modal';

import './style.scss';

const InfoModal = ({ isOpened, onToggle = () => {} }) => {
  const intl = useIntl();
  const [isModalOpened, setModalOpen] = useStateFromProp(isOpened, onToggle);

  return (
    <Modal.Wrapper isOpened={isModalOpened} onClose={() => setModalOpen()} className="c-modal--plain c-modal--narrow">
      <Modal.Content>
        <h2 className="l-headline--secondary c-modal__headline">
          {intl.formatMessage({
            id: 'containers.contact-options.push-notifications.modal.headline',
            defaultMessage: 'Enable Push notifications in browser',
          })}
        </h2>
        <p>
          {intl.formatMessage({
            id: 'containers.contact-options.push-notifications.modal.content',
            defaultMessage:
              'Your browser is currently not allowing push notifications. Use browser options to enable push notifications.',
          })}
        </p>
      </Modal.Content>
    </Modal.Wrapper>
  );
};

const PushNotifications = () => {
  const intl = useIntl();
  const { notificationsPermission, startPusher } = useContext(PusherContext);
  const [isInfoModalOpened, setIsInfoModalOpened] = useState(false);

  const handleDefaultPushNotifications = () => {
    startPusher();
  };

  return (
    <div className="c-group c-group--centered">
      <div className="c-group__label">
        {intl.formatMessage({
          id: 'containers.contact-options.push-notifications.label',
          defaultMessage: 'Push notifications',
        })}
      </div>
      <div className="c-group__value">
        {notificationsPermission === 'granted' && (
          <span className="c-contact-options__success">
            <FiCheck />
          </span>
        )}
        {notificationsPermission === 'default' && (
          <Button className="c-btn--text" onClick={handleDefaultPushNotifications}>
            {intl.formatMessage({
              id: 'containers.contact-options.push-notifications.enable',
              defaultMessage: 'Enable',
            })}
          </Button>
        )}
        {notificationsPermission === 'denied' && (
          <Button className="c-btn--text" onClick={setIsInfoModalOpened}>
            {intl.formatMessage({
              id: 'containers.contact-options.push-notifications.enable',
              defaultMessage: 'Enable',
            })}
          </Button>
        )}
        {!notificationsPermission && (
          <Button className="c-btn--text" disabled>
            {intl.formatMessage({
              id: 'containers.contact-options.push-notifications.not-supported',
              defaultMessage: 'Not supported',
            })}
          </Button>
        )}
      </div>
      <InfoModal isOpened={isInfoModalOpened} onToggle={setIsInfoModalOpened} />
    </div>
  );
};

export default PushNotifications;
